<template>
  <div class="abouindex">564aaaa365</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style>
</style>